import { ESSENTIALS_CONTENT_CATEGORY } from '../../essentials/types'
import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

/** CIS Grief toolkit */
export const cisGriefToolkitMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.CIS_GRIEF,
  iFrameSrcUrl: '/grief-cis-toolkit',
  micrositeUrl: 'grief-cis-toolkit',
  title: {
    id: 'cisGrief.title',
    defaultMessage: 'Finding your way through grief',
    description: 'Microsite page title',
  },
  featureFlag: 'oct2025ToolkitsEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    {
      key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT,
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
      params: {
        webinarLink: '/secure/index/essentials/events',
      },
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_FORKED_TRIAGE },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_ESSENTIALS,
      params: {
        category: ESSENTIALS_CONTENT_CATEGORY.TOPIC,
        slug: 'coping-with-crisis',
      },
    },
  ],
  page: 'CIS grief',
  trackUTMParams: {
    utm_campaign: 'CISgrief',
  },
  customMixpanelEventProps: {
    toolkit_topic: 'CISgrief',
  },
  shouldHideForInternational: true,
}
